import { THEME_ENUM } from '@/constants/theme.constant'
import { THEME_COLOR, THEME_LEVEL } from '../../tailwind.config.js'


export const themeConfig = {
    themeColor: THEME_COLOR,
    direction: THEME_ENUM.DIR_LTR,
    mode: THEME_ENUM.MODE_DARK,
    locale: 'en',
    primaryColorLevel: THEME_LEVEL,
    cardBordered: true,
    panelExpand: false,
    controlSize: 'md',
    navMode: THEME_ENUM.MODE_DARK,
    layout: {
        type: 'modern',
        sideNavCollapse: false,
    },
}
